import Fetch from 'jsx/common/util/_fetch';

export const remove = async (memberId: number) => {
  return Fetch.delete(`/api/user/group/${memberId}/`);
};
